import { AutogenLayoutStopProgressQuickInfo } from "./autogen/AutogenLayoutStopProgressQuickInfo";
import { Label, Panel, TableRowDisplayEvent } from "@mcleod/components";

export class StopProgressQuickInfo extends AutogenLayoutStopProgressQuickInfo {
    /** This is an event handler for the onRowDisplay event of tableStopProgress. */
    tableStopProgressOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data;
        const actualArrival = modelRow.get("actual_arrival", null);
        const actualDeparture = modelRow.get("actual_departure", null);
        const statusPanel = tableRow.findComponentById("panelStatusBadge") as Panel;
        const labelStatusBadge = tableRow.findComponentById("labelStatus") as Label;
        const labelStopNumber = tableRow.findComponentById("labelStopNumber") as Label;
        if (actualArrival != null || actualDeparture != null) {
            labelStatusBadge.backgroundColor = actualArrival != null && actualDeparture != null ? "warning" : "success";
            labelStatusBadge.text = actualArrival != null && actualDeparture != null ? "Departed" : "Arrived";
            statusPanel.visible = labelStatusBadge.visible = true;
        }
        if (modelRow.isNull("order_sequence") && !modelRow.isNull("movement_sequence")) {
            labelStopNumber.text = modelRow.get("movement_sequence");
        } 
    }
}
